import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPUkraineInquiryData } from "@/src/types/admissionOffice";
import type { InquiryBasicCountry } from "./inquiryBasicRegistry";

const emptyInquiryState = (): AOPUkraineInquiryData => ({
  whose_doc: "",
  date: "",
  dateCertification: "",
  documentNumber: "",
  fullName: "",
  fullNameSecondLine: "",
  speciality: "",
  dateEnd: "",
  numberSolution: "",
  dateSolution: "",
  need_qr: true,
});

export interface AOPInquiryBasicLayoutProps {
  country: InquiryBasicCountry;
}

const AOPInquiryBasicLayout = ({ country }: AOPInquiryBasicLayoutProps) => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPUkraineInquiryData>(emptyInquiryState);
  const [bodyForPrev, setBodyForPrev] = useState<AOPUkraineInquiryData>(emptyInquiryState);

  return (
    <div className="container admission-office-page">
      <AOPConfig
        country={country}
        dataForGeneration={dataForGeneration}
        setDataForGeneration={setDataForGeneration}
        setBodyForPrev={setBodyForPrev}
      />
      <AOPPrev country={country} bodyForPrev={bodyForPrev} />
    </div>
  );
};

export default AOPInquiryBasicLayout;
